'use strict';

/**
 * Booking intake modal curve data
 */
var BookingsIntakeModalTransformerFactory = function BookingsIntakeModalTransformerFactory(DataTransformer, bookingsIntakeTransformationService) {
  function BookingsIntakeModalTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['service-bookings-intake', 'service-management-bookings-intake', 'market-bookings-intake', 'cabin-bookings-intake', 'class-bookings-intake', 'market-product-group-bookings-intake', 'segment-classes-bookings-intake'];
    this.targetType = ['bookings-intake-modal'];
    this.priority = 1;
  }
  BookingsIntakeModalTransformer.prototype = Object.create(DataTransformer.prototype);
  BookingsIntakeModalTransformer.constructor = BookingsIntakeModalTransformer;
  BookingsIntakeModalTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.targetType.indexOf(targetType) > -1 && this.sourceType.indexOf(sourceType) > -1;
  };
  BookingsIntakeModalTransformer.prototype.isCacheable = function () {
    return false;
  };
  BookingsIntakeModalTransformer.prototype.getCacheKey = function () {
    return this.sourceType.join('-') + '-' + this.targetType.join('-');
  };
  BookingsIntakeModalTransformer.prototype.transform = function (data, metric, metricDescriptor) {
    var transformationParams = metricDescriptor && metricDescriptor.params ? metricDescriptor.params : {};
    var curveData = data && data.domain && data.domain.flattenedDomainCurves ? data.domain.flattenedDomainCurves[0] : {};
    var bookingsCurrent = transformationParams.bookingsCurrent;
    var bookingsCurrentLY = transformationParams.bookingsCurrentLY;
    var bookingsCurrentRY = transformationParams.bookingsCurrentRY;
    var daysToDeparture = transformationParams.daysToDeparture;
    var customDtd = transformationParams.customDtd;
    return bookingsIntakeTransformationService.transformCurveData(curveData, bookingsCurrent, bookingsCurrentLY, bookingsCurrentRY, daysToDeparture, customDtd);
  };
  return BookingsIntakeModalTransformer;
};
BookingsIntakeModalTransformerFactory.$inject = ['DataTransformerFactory', 'BookingsIntakeTransformationService'];
module.exports = BookingsIntakeModalTransformerFactory;